import GlobalToastType from '../types/GlobalToastType';
import createToast from '../../services/GlobalToastService';

const addToast = (options = {}) => {
  return {
    payload: createToast(options),
    type: GlobalToastType.actions.addToast,
  };
};

const showError = (text) => {
  return addToast({
    text,
    color: 'danger',
  });
};

const showRequestError = (error) => {
  const { response = {} } = error;
  const msgError = (response.data && response.data.description) || 'labelNetworkError';
  return showError(msgError);
};

const showWarning = (text, dismiss) => {
  return addToast({
    text,
    color: 'warning',
    dismiss: dismiss || 5000,
  });
};

const showSuccess = (text) => {
  return addToast({
    text,
    color: 'success',
  });
};

const removeToast = (id) => ({ payload: id, type: GlobalToastType.actions.removeToast });

export { addToast, showError, showRequestError, showWarning, showSuccess, removeToast };
